import { render, staticRenderFns } from "./EditSoftwareList.vue?vue&type=template&id=1f11f1d4"
import script from "./EditSoftwareList.vue?vue&type=script&lang=js"
export * from "./EditSoftwareList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports